import { createSystem, defaultConfig, defineConfig } from '@chakra-ui/react';
import { tokens, semanticTokens } from './tokens';
import { recipes } from './recipes';
import { textStyles } from './textStyles';

const config = defineConfig({
  cssVarsRoot: ':where(:root, :host)', // cssVarsRoot is the root element where the token CSS variables will be applied.
  cssVarsPrefix: 'ck', // cssVarsPrefix is the prefix for the CSS variables.
  // globalCss is the global CSS styles that will be applied to the application.
  globalCss: {
    'html, body': {
      margin: 0,
      padding: 0,
      colorPalette: 'primary',
      color: 'fg',
      bg: 'bg',
    },
  },
  /* theme is the theme object that contains all the tokens, recipes, and other styles.
        breakpoints: for defining breakpoints
        keyframes: for defining css keyframes animations
        tokens: for defining tokens
        semanticTokens: for defining semantic tokens
        textStyles: for defining typography styles
        layerStyles: for defining layer styles
        animationStyles: for defining animation styles
        recipes: for defining component recipes
        slotRecipes: for defining component slot recipes
*/
  theme: {
    tokens,
    semanticTokens,
    textStyles,
    recipes,
    breakpoints: {
      base: '0em',
      sm: '480px',
      md: '768px',
      lg: '1024px',
      xl: '1280px',
      '2xl': '1536px',
    },
  },

  // conditions is used to define conditions for the recipes
  conditions: {
    conditions: {
      cqSm: '@container(min-width: 320px)',
      child: '& > *',
    },
  },
});

const system = createSystem(defaultConfig, config);
export default system;
